const axios = require('axios');

// eslint-disable-next-line prefer-destructuring
const ENDPOINT = process.env.ENDPOINT;

axios.defaults.baseURL = ENDPOINT;
